import { useEffect, useRef } from 'react';

/**
 * Tracks scroll depth, CTA clicks, and time on page.
 * Fires Meta Pixel custom events when thresholds are reached.
 */
export const useEngagementTracking = () => {
  const scrollMilestones = useRef(new Set<number>());
  const startTime = useRef(Date.now());

  useEffect(() => {
    const handleScroll = () => {
      const scrollPct = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );

      [25, 50, 75, 100].forEach(milestone => {
        if (scrollPct >= milestone && !scrollMilestones.current.has(milestone)) {
          scrollMilestones.current.add(milestone);
          window.fbq?.('trackCustom', 'ScrollDepth', { depth: milestone });
        }
      });
    };

    const handleBeforeUnload = () => {
      const seconds = Math.round((Date.now() - startTime.current) / 1000);
      window.fbq?.('trackCustom', 'TimeOnPage', { seconds });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const trackCTAClick = (ctaName: string) => {
    window.fbq?.('trackCustom', 'CTAClick', { cta: ctaName });
  };

  return { trackCTAClick };
};
